import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import ingoingOutgoingIcon from "../../../../../assets/design-revamp-company/company-detail-headers/ingoing-outgoing-icon.svg";
import { useTranslation } from "react-i18next";
import { getIngoingOutgoingTotal } from "../../../../../apis/Business/IngoingOutgoingTotalApi";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import ingoingGraphic from "../../../../../assets/design-revamp-company/company-detail-headers/ingoing-graphic-icon.svg";
import outgoingGraphic from "../../../../../assets/design-revamp-company/company-detail-headers/outgoing-graphic-icon.svg";

const IngoingOutgoingIcon = () => (
  <img
    src={ingoingOutgoingIcon}
    alt="Transport Delivery Icon"
    width={76}
    height={76}
  />
);

const TransportDeliveryHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  businessId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalObjIngoingOutgoing, setTotalObjIngoingOutgoing] = useState([]);
  useEffect(() => {
    getIngoingOutgoingTotal({
      businessId: businessId,
      setTotalObj: setTotalObjIngoingOutgoing,
    });
  }, [businessId]);

  return (
    <CategoryComponent
      show={show}
      className={`ingoing-outgoing-category ${className || ""}`}
      noSystemBoundary
      leftBoxProps={{
        icon: <IngoingOutgoingIcon />,
        title: t("INGOING_OUTGOING_TRANSPORT"),
        graphicIcons: [{ icon: ingoingGraphic }, { icon: outgoingGraphic }],
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_CATEGORY"),
            items: [
              {
                subtitle: t("EXPENSES"),
                subitems: [
                  {
                    label: "DKK",
                    value: handleToFixedNum(
                      totalObjIngoingOutgoing,
                      totalObjIngoingOutgoing?.total_expenses
                    ),
                  },
                ],
              },
              {
                subtitle: `${t("EMISSIONS")} ${handleToFixedNum(
                  totalObjIngoingOutgoing,
                  totalObjIngoingOutgoing?.total_emissions
                )} (tCO₂e)`,
                subitems: [
                  {
                    value: handleToFixedNum(
                      totalObjIngoingOutgoing,
                      totalObjIngoingOutgoing.total_ingoing
                    ),
                    scopes: ["S:3, C:4"],
                  },
                  {
                    value: handleToFixedNum(
                      totalObjIngoingOutgoing,
                      totalObjIngoingOutgoing.total_outgoing
                    ),
                    scopes: ["S:3, C:9"],
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjIngoingOutgoing?.updated_at
          ? formatDate(totalObjIngoingOutgoing?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default TransportDeliveryHeader;
